<template>
  <div @scroll="handleMainContainerScroll">
    <a-spin :spinning="loading" class="center-spinner">
      <a-icon slot="indicator" style="font-size: 80px" type="loading" />
    </a-spin>

    <div
      ref="main-container"
      v-if="citRequest"
      style="min-height: 100vh; position: relative"
    >
      <a-row>
        <a-col :span="24">
          <div>
            <p class="cst-blue-header">Müraciətə aid məlumatlar</p>

            <a-row>
              <a-col :span="11" class="header__first__container">
                <div class="info-container">
                  <ul class="info-list">
               
                    <li><b>Müraciət nömrəsi:</b> {{ citRequest.number }}</li>
                    <li>
                      <b>Müraciət edən şəxs:</b>
                      <span v-if="citRequest.citizen">{{
                        citRequest.citizen.firstName +
                        " " +
                        citRequest.citizen.lastName +
                        " " +
                        citRequest.citizen.fatherName
                      }}</span>
                      <span v-else>Məlumat tapılmadı</span>
                    </li>
                    <li>
                      <b>Əlaqə nömrəsi:</b>
                      <span> {{ citRequest.citizen.mobilePhoneNumber }}</span>
                      <span v-if="citRequest.citizen.whatsappNumber">
                        ,<img
                          src="../../../assets/imgs/whatsapp.png"
                          style="width: 24px; vertical-align: middle"
                        />
                        {{ citRequest.citizen.whatsapNumber }}
                      </span>
                      <span v-if="citRequest.citizen.homePhoneNumber">
                        ,{{ citRequest.citizen.homePhoneNumber }}
                      </span>
                    </li>

                    <!--                     <div v-if="citRequest">
                      <a-collapse :bordered="false">
                        <a-collapse-panel header="Tarixçə:" @change="getHistory">
                          <li
                            v-for="x in citRequest.textHistory"
                            style="max-height: 300px; overflow: auto"
                            :key="`${x.text}-${x.dateStr}`"
                          >
                            <div style="color: red">
                              {{ x.step }} -
                              <span style="color: black">
                                {{
                                  `${x.user.firstName} ${x.user.lastName}, ${x.user.fatherName}`
                                }}
                              </span>
                            </div>
                            <div><b>Qeyd:</b> {{ x.text }}</div>
                            <div><b>Tarix:</b> {{ x.dateStr }}</div>
                          </li>
                        </a-collapse-panel>
                      </a-collapse>
                    </div> -->

                    <a-button
                      @click="historyVisible = true"
                      style="margin: 6px"
                    >
                      Əməliyyatlar
                    </a-button>

                    <RequestHistoryModal
                      :visible="historyVisible"
                      :request="citRequest"
                      @afterClose="handleAssestmentModalClose"
                    />

                    <li v-if="citRequest.otherCitizens">
                      <b style="display: block">Digər müraciətçilər</b>
                      <div
                        v-for="(cit, index) in citRequest.otherCitizens"
                        :key="index"
                        class="citizen-item"
                      >
                        <div>
                          {{
                            cit.firstName +
                            " " +
                            cit.lastName +
                            " " +
                            cit.fatherName
                          }}
                        </div>
                        <div>{{ cit.mobilePhoneNumber }}</div>
                      </div>
                    </li>
                  </ul>
                  <a-tag
                    color="#009989"
                    style="position: absolute; top: 5px; right: 10px"
                  >
                    {{ citRequest.citizenJoined ? "Qoşulmuş" : "Yeni" }}
                  </a-tag>
                </div>
           
                <div v-if="selectedProblem" style="position: relative">
                  <a-alert
                    :message="
                      selectedProblem.number + ' №-li şikayətə birləşdirilib'
                    "
                    type="success"
                  />
               
                  <a-button
                    type="danger"
                    style="
                      position: absolute;
                      right: 80px;
                      top: 0;
                      height: 100%;
                    "
                    @click="chooseDetail(selectedProblem)"
                    >Ayır</a-button
                  >
                  <a-button
                    type="primary"
                    style="position: absolute; right: 0; top: 0; height: 100%"
                    @click="getDetailed(selectedProblem)"
                    >Ətraflı</a-button
                  >
                </div>

                <div v-if="citRequest.joinedRequest">
                  <a-alert
                    :message="
                      citRequest.joinedRequest.number.pad(6) +
                      ' №-li müraciətə qoşulub'
                    "
                    type="success"
                  />
                      <a-button
                    type="danger"
                    style="
                      float:right;
                     transform:translate(-16px,-30px)
                    "
                    @click="chooseDetail(citRequest.joinedRequest)"
                    >Ayır</a-button>
                </div>

                <cit-problem-form
                  v-if="citRequest"
                  ref="cproblemForm"
                  :request="citRequest"
                  :isJoined="selectedProblem != null"
                  :executive="
                    selectedProblem
                      ? selectedProblem.executive
                      : citRequest.executive
                  "
                  :title="
                    selectedProblem ? selectedProblem.title : citRequest.title
                  "
                  :address="citRequest.address"
                  :priorityLevel="
                    selectedProblem
                      ? selectedProblem.priorityLevel
                      : citRequest.priorityLevel
                  "
                  :type="citRequest.type"
                  :cats="selectedProblem ? selectedProblem.categories : citRequest.categories"
                  :execs="
                    selectedProblem
                      ? selectedProblem.execStructures
                      : citRequest.execStructures
                  "
                ></cit-problem-form>
              </a-col>

              <a-col :span="11" :offset="1" class="header__first__container">
                <div
                  v-if="citRequest.cancellation"
                  style="color: red; font-size: 32px; text-align: right"
                >
                  İmtina edilib
                </div>

                <div
                  v-else-if="citRequest.resultProblems"
                  style="
                    color: red;
                    font-size: 32px;
                    display: flex;
                    flex-direction: column;
                  "
                >
                  <span
                    style="
                      padding: 2.5px 0;
                      border-bottom: 1px solid gray;
                      text-align: center;
                    "
                  >
                    Təsdiq edilib
                  </span>

                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: flex-end;
                      color: black;
                      font-size: 20px;
                    "
                  >
                    <p style="margin-bottom: 5px">Şikayətlər</p>

                    <div
                      style="
                        display: flex;
                        width: 100%;
                        justify-content: flex-end;
                        flex-wrap: wrap;
                      "
                    >
                      <a-button
                        v-for="problem in citRequest.resultProblems"
                        :key="problem.id"
                        @click="handleOpenProblem(problem.id)"
                      >
                        {{ problem.title }}
                      </a-button>
                    </div>
                  </div>
                </div>

                <div
                  style="display: flex; flex-direction: column; margin: 10px 0"
                >
                  <div
                    style="
                      display: flex;
                      justify-content: flex-end;
                      margin-bottom: 5px;
                      width: 100%;
                    "
                  >
                    <div style="margin-right: 15px">
                      Qoşulmuş: {{ joinedRequestsCount }}
                    </div>
                    <div style="margin-right: 15px">
                      Baxılacaq müraciət: {{ nearRequestsCount }}
                    </div>
                    <div>İcrada olan: {{ nearProblemsCount }}</div>
                    <!-- <div>Tamamlanmışla: {{ completedRequestCount }}</div> -->
                  </div>

                  <div style="display: flex; justify-content: flex-end">
                    <a-button
                      v-for="button in actions"
                      :ref="button.id + 'ref'"
                      class="custom__color"
                      size="large"
                      :key="button.id"
                      @click="submit(button)"
                      :style="{ color: 'white' }"
                    >
                      {{ button.name }}
                    </a-button>
                  </div>
                  <!-- <a-button type="danger" size="large" @click="reasonsModalVis=true" style="margin-left: 10px;">Aid deyil </a-button>
                            <a-button type="primary" size="large" style="margin-left: 10px;" @click="submit">Əlavə et</a-button> -->
                </div>
                <a-alert
                  v-if="citRequest.lastOperation && !citRequest.cancellation"
                  :message="citRequest.lastOperation"
                />
             <!--    <a-alert
                  v-if="citRequest.cancellation"
                  :message="citRequest.cancellation.note"
                >
                </a-alert> -->
                <google-address-list
                  :addresses="citRequest.addresses"
                ></google-address-list>
                <g-map
                  :latitude="citRequest.latitude"
                  :longitude="citRequest.longitude"
                ></g-map>

                <div
                  v-if="citRequest.parent"
                  style="
                    margin-top: 10px;
                    border: 1px solid #f0f0f0;
                    padding: 10px;
                  "
                >
                  <h2>Təkrar müraciətlər</h2>

                  <div
                    style="
                      display: flex;
                      align-items: center;
                      width: 100%;
                      padding: 10px 0;
                    "
                  >
                    <div style="width: 150px; padding: 0 15px">
                      <problem-cover
                        :problem="citRequest.parent[0]"
                      ></problem-cover>
                    </div>

                    <div style="width: 150px">
                      {{ citRequest.parent[0].dateStr }}
                    </div>

                    <div
                      style="
                        width: calc(100% - 300px);
                        display: flex;
                        justify-content: flex-end;
                      "
                    >
                      <a-button @click="handleCancelReApply">İmtina</a-button>
                    </div>
                  </div>

                  <a-modal
                    :footer="null"
                    v-model="cancelReAppleConfirmModal"
                    title="Təkrar müraciəti imtina etmək"
                  >
                    <div style="display: flex; justify-content: center">
                      <a-button @click="handleCancelReApplyOk">
                        Təsdiq
                      </a-button>
                    </div>
                  </a-modal>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
      </a-row>

      <a-row
        style="margin: 0"
        :gutter="6"
        v-if="citRequest.filesList && citRequest.filesList.length > 0"
      >
        <p class="cst-blue-header" ref="compare-field">
          Əlavə olunmuş fayllar
          <a-button
            style="float: right"
            :type="compType ? 'warning' : 'default'"
            @click="toggleCompare"
          >
            {{ compType ? "Geri" : "Müqayisə et" }}</a-button
          >
        </p>
        <a-col :span="compType ? 12 : 15" class="map__side__media">
          <conditional-media
            :filesList="citRequest.filesList"
            @change="handleFileChange"
            @coverChanged="onMainMediaChange"
            :cover="coverMedia"
          ></conditional-media>
        </a-col>

        <a-col :span="compType ? 12 : 9" class="map__top__media">
          <div
            v-if="selectedFile && !compType"
            style="margin: px 0px 0 10px; height: 40px"
          >
            <a-checkbox
              :checked="selectedFile.sameAddress"
              @change="onSameAddChange"
              :disabled="citRequest.filesList.length <= 1"
            >
              Eyni ünvan/Eyni müraciət
            </a-checkbox>

            <a-button
              type="primary"
              v-if="
                !selectedFile.sameAddress &&
                actions.length > 0 &&
                citRequest.filesList.length > 1
              "
              style="float: right"
              @click="prfileVis = true"
              >Əlavə et</a-button
            >
          </div>

          <conditional-media
            v-if="compareProblem && compType && compareProblem.filesList"
            :filesList="compareProblem.filesList"
            :cover="compareProblem.coverMedia"
            ref="conditional-media"
          ></conditional-media>

          <p
            v-if="!compareProblem && compType"
            style="
              color: gray;
              text-align: center;
              margin-top: 160px;
              font-size: 16px;
            "
          >
            Zəhmət olmasa qarşılaşdırma üçün aşağıdakı şikayətlərdan birini
            seçin
          </p>

          <a-alert
            type="warning"
            v-if="selectedFile && !compType"
            show-icon
            :message="
              ' Əsas yer ilə ' +
              (selectedFile.distance ? selectedFile.distance.toFixed(2) : 0.0) +
              ' m məsafədə'
            "
            style="margin: 0px 10px 0 10px; font-size: 14px"
          ></a-alert>

          <google-address-list
            v-if="selectedFile && !compType"
            :addresses="selectedFile.addresses"
          ></google-address-list>
          <g-map
            v-if="selectedFile && !compType"
            :latitude="selectedFile.latitude"
            :longitude="selectedFile.longitude"
          ></g-map>
        </a-col>
      </a-row>

      <a-row
        style="margin-top: 10px; margin-bottom: 10px"
        v-if="citRequest && !citRequest.citizenCancelled"
      >
        <h2 class="cst-blue-header">Qoşulmuşlar</h2>
        <citizen-requests
          :loading="joinedLoading"
          @change="handleTableChange"
          :dataSource="joinedRequests"
          :totalCount="joinedRequestsCount"
          @row-selection-change="handleRowSelection"
          :showFiles="true"
          :detailButton="false"
          :editButton="true"
        ></citizen-requests>
      </a-row>

      <a-row v-if="citRequest && !citRequest.citizenCancelled">
        <h2 class="cst-blue-header">Baxılacaq müraciət (50 m)</h2>
        <a-tabs default-active-key="wtab1">
          <a-tab-pane key="wtab1" tab="50m">
            <citizen-requests
              :loading="nearRequestsLoading"
              :dataSource="nearRequests"
              :totalCount="nearRequests.length"
              @row-selection-change="handleRowSelection"
              :checkable="true"
              :showFiles="true"
              :detailButton="false"
              :editButton="true"
            ></citizen-requests>
          </a-tab-pane>
          <a-tab-pane key="wtab2" tab="75m">
            <citizen-requests
            :checkable="true"
              :loading="nearRequestsLoading"
              :dataSource="nearRequests"
              :totalCount="nearRequests.length"
              @row-selection-change="handleNRowSelection"
              :showFiles="true"
              :detailButton="false"
              :editButton="true"
            ></citizen-requests>
          </a-tab-pane>
          <a-tab-pane key="wtab3" tab="100m">
            <citizen-requests
            :checkable="true"
              :loading="nearRequestsLoading"
              :dataSource="nearRequests"
              :totalCount="nearRequests.length"
              @row-selection-change="handleNRowSelection"
              :showFiles="true"
              :detailButton="false"
              :editButton="true"
            ></citizen-requests>
          </a-tab-pane>
          <a-tab-pane key="wtab4" tab="150m">
            <citizen-requests
              :checkable="true"
              :loading="nearRequestsLoading"
              :dataSource="nearRequests"
              :totalCount="nearRequests.length"
              @row-selection-change="handleNRowSelection"
              :showFiles="true"
              :detailButton="false"
              :editButton="true"
            ></citizen-requests>
          </a-tab-pane>
        </a-tabs>
      </a-row>

      <a-row v-if="citRequest">
        <a-col :span="24">
          <h2 class="cst-blue-header">İcrada olan müraciətlər</h2>

          <a-tabs default-active-key="tab1">
            <a-tab-pane key="tab1" tab="50m">
              <near-problems-table
                :distance="50"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="false"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                @total-count-change="handleNearProblemsTotalCountChange"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
            <a-tab-pane key="tab2" tab="75m">
              <near-problems-table
                :distance="75"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="false"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                @total-count-change="handleNearProblemsTotalCountChange"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
            <a-tab-pane key="tab3" tab="100m">
              <near-problems-table
                :distance="100"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="false"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                @total-count-change="handleNearProblemsTotalCountChange"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
            <a-tab-pane key="tab4" tab="150m">
              <near-problems-table
                :distance="150"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="false"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                @total-count-change="handleNearProblemsTotalCountChange"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
            <a-tab-pane key="tab5" tab="200m">
              <near-problems-table
                :distance="200"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="false"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                @total-count-change="handleNearProblemsTotalCountChange"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
            <a-tab-pane key="tab6" tab="500m">
              <near-problems-table
                :distance="500"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="false"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                @total-count-change="handleNearProblemsTotalCountChange"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
            <a-tab-pane key="tab7" tab="1000m">
              <near-problems-table
                :distance="1000"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="false"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                @total-count-change="handleNearProblemsTotalCountChange"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="24">
          <h2 class="cst-blue-header">Yekunlaşdırılmış</h2>
          <a-tabs default-active-key="tab1">
            <a-tab-pane key="tab1" tab="50m">
              <near-problems-table
                :distance="50"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="true"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
            <a-tab-pane key="tab2" tab="75m">
              <near-problems-table
                :distance="75"
                :latitude="citRequest.latitude"
                :longitude="citRequest.longitude"
                :completed="true"
                @problem-chosen="chooseDetail"
                @click-compare="handleCompare"
                :selected="selectedProblem"
              ></near-problems-table>
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>

      <my-confirm
        v-if="dataToSend"
        :visible="confirmModalVis"
        :askReason="dataToSend.action.askReason"
        :title="dataToSend.action.name"
        :initialReason="citRequest.reasonNote"
        @afterClose="handleConfirmClose"
        @onOk="handleConfirmOk"
      />

      <problem-file-modal v-if="selectedFile" :request="citRequest"
      :visible="prfileVis" :file="selectedFile"
      :filesList="citRequest.filesList" @afterClose="afterPrFrClose"
      :executive="selectedFile.executive" :title="citRequest.text"
      actions:="actions" />

      <button
        @click="handleGoUp"
        class="btn-go-top"
        :style="{ display: btnUpVisible ? 'initial' : 'none' }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="50"
          height="50"
          viewBox="0 0 50 50"
        >
          <path
            d="M 43.652344 50.003906 C 40.652344 50.003906 14.632813 49.210938 14.011719 22 L 3.59375 22 L 20 0.34375 L 36.410156 22 L 26.011719 22 C 26.472656 46.441406 43.894531 47.988281 44.074219 48.003906 L 44.035156 50 C 44.035156 50 43.902344 50.003906 43.652344 50.003906 Z"
          ></path>
        </svg>
      </button>
    </div>

    <detail-modal
      :visible="detailModalVis"
      :problemOb="selectedProblem"
      @afterClose="handleModalClose"
    ></detail-modal>
  </div>
</template>

<script>
import { URL, apiCall } from "@/utils/api";
import mixin from "@/mixins/index";
import ConditionalMedia from "@/components/partials/ConditionalMedia/index";
import Map from "@/components/partials/Map/index";
import GoogleAddressList from "@/components/partials/GoogleAddressList";
import NearProblemsTable from "@/components/partials/NearProblemsTable";
import CitProblemForm from "@/components/partials/CitProblemForm/index";
import ProblemFromFileModal from "@/components/pages/Modals/ProblemFromFileModal/index.vue";
import ReasonsModal from "@/components/pages/Modals/ReasonsModal/index.vue";
import CitizenRequestsTable from "@/components/partials/CitizenRequestsTable/index";
import MyConfirmModal from "@/components/pages/Modals/MyConfirmModal/index";
import EventBus from "@/EventBus";
import ProblemCoverCol from "@/components/partials/ProblemCoverCol";
import DetailModal from "@/components/pages/Modals/DetailModal/index";
import RequestHistoryModal from "@/components/pages/Modals/RequestHistoryModal";
import { getCookie, removeRequestCookie } from "@/utils/cookie";

export default {
  name: "CitizenRequest",
  mixins: [mixin],
  components: {
    "conditional-media": ConditionalMedia,
    "g-map": Map,
    "google-address-list": GoogleAddressList,
    "near-problems-table": NearProblemsTable,
    "cit-problem-form": CitProblemForm,
    "problem-file-modal": ProblemFromFileModal,
    "reasons-modal": ReasonsModal,
    "citizen-requests": CitizenRequestsTable,
    "my-confirm": MyConfirmModal,
    "problem-cover": ProblemCoverCol,
    "detail-modal": DetailModal,
    RequestHistoryModal,
  },
  data() {
    return {
      forRefButtonId: null,
      historyVisible: false,
      selectedProblem: null,
      detailModalVis: false,
      citRequest: null,
      selectedFile: null,
      strSearchTimeout: null,
      newProblems: [],
      exist: false,
      compType: false,
      compareProblem: null,
      coverMedia: null,
      title: null,
      prfileVis: false,
      reasonsModalVis: false,
      actions: [],
      joinedLoading: false,
      joinedRequests: [],
      joinedRequestsCount: 0,
      pagination: { current: 1, pageSize: 10 },
      joinedRequestIds: [],
      nearRequests: [],
      nearRequestsLoading: false,
      nearRequestsCount: 0,
      nearProblemsCount: 0,
      selectedNearRequestIds: [],
      dataToSend: null,
      confirmModalVis: false,
      loading: false,
      selectedRowKeys: [],
      willCallBeforeDestroy: true,
      created: false,
      cancelReAppleConfirmModal: false,
      prevProblemId: undefined,
      prevProblemStatus: 0,

      btnUpVisible: false,
      replaceFields: {
        children: "parent",
        title: "address",
        key: "address",
      },
    };
  },
  beforeUnmount(){
      console.warn('called before unmo');
  },
  methods: {
    hadddd(){  EventBus.$emit("setMainData", { data:'hello' });},
    handleAssestmentModalClose() {
      this.historyVisible = false;
    },
    historyDetail() {
      this.historyVisible = true;
    },
    handleMainContainerScroll(e) {
      if (
        e.srcElement.scrollingElement.clientHeight / 2 -
          e.srcElement.scrollingElement.scrollTop >
        0
      )
        this.btnUpVisible = false;
      else this.btnUpVisible = true;
    },
    getDetailed(problem) {
      this.selectedProblem = problem;

      this.detailModalVis = true;
    },
    handleGoUp() {
      this.$refs["main-container"].scrollIntoView({ behavior: "smooth" });
    },

    handleCancelReApply() {
      this.cancelReAppleConfirmModal = true;
    },

    handleCancelReApplyOk() {
      this.prevProblemStatus = 0;
      this.cancelReAppleConfirmModal = false;
    },

    getCitRequestDetails() {
      if (!this.$route.params.id) return;
      this.loading = false;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "requests/" +
          this.$route.params.id,
        params: {
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.citRequest = response.data.data;

            this.coverMedia = this.citRequest.coverMedia;

            if (!this.coverMedia && this.citRequest.filesList.length === 1) {
              this.coverMedia = this.citRequest.filesList[0].path;
            }

            if (this.citRequest.parent && this.citRequest.parent[0]) {
              this.prevProblemId = this.citRequest.parent[0].id;
              this.prevProblemStatus = 1;
            } else {
              this.prevProblemStatus = 0;
            }

            // this.prevProblemId = this.citRequest?.parent[0]?.id;
            // this.prevProblemStatus = this.citRequest?.parent[0] ? 1 : 0;

            this.citRequest.title = this.citRequest.title
              ? this.citRequest.title.capitalizeFLetter()
              : this.citRequest.text
              ? this.citRequest.text.capitalizeFLetter()
              : "";
            this.selectedExecutiveId = this.citRequest.executive
              ? this.citRequest.executive.id
              : null;

            this.$set(
              this.citRequest,
              "selectedExecutiveId",
              this.citRequest.executive ? this.citRequest.executive.id : null
            );
            if (this.citRequest.joinedProblem) {
              this.chooseDetail(
                this.citRequest.joinedProblem,
                this.citRequest.address
              );
            }

            if (
              !this.citRequest.cancellation &&
              !this.citRequest.resultProblems
            ) {
              this.getActions();
            }
            this.getJoinedRequests(this.pagination);
            this.getNearRequests();
          } else this.$message.error(response.data.error.message);
          this.loading = false;

          // const edits = JSON.parse(getCookie("activeEdits"));
          // let newEdits;

          // if (!edits)
          //   newEdits = {
          //     [this.$route.params.id]: {
          //       isOpen: true,
          //       editor: `${this.userData.firstName} ${this.userData.lastName}`,
          //     },
          //   };
          // else
          //   newEdits = {
          //     ...edits,
          //     [this.$route.params.id]: {
          //       isOpen: true,
          //       editor: `${this.userData.firstName} ${this.userData.lastName}`,
          //     },
          //   };

          // const domain =
          //   process.env.NODE_ENV === "development"
          //     ? "localhost"
          //     : ".muraciet.az";

          // document.cookie = `activeEdits=${JSON.stringify(
          //   newEdits
          // )}; domain=${domain}; path=/;`;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onMainMediaChange(file) {
      if (file) {
        this.coverMedia = file.path;
      }
    },
    handleModalClose() {
      this.detailModalVis = false;
      /*  this.selectedProblem = null; */
    },
    getNearRequests() {
      this.nearRequestsLoading = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "requests/nearRequests",
        params: {
          longitude: this.citRequest.longitude,
          latitude: this.citRequest.latitude,
          distance: 50,
          sameStatus: true,
          completed: false,
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.nearRequests = response.data.data.entities.filter(
              (item) => item.id !== this.citRequest.id
            );
            this.nearRequestsCount = response.data.data.totalCount;
          }
          this.nearRequestsLoading = false;
        })
        .catch((err) => {
          this.nearRequestsLoading = false;
          this.$message.error("Xəta baş verdi");
        });
    },
    afterPrFrClose() {
      this.prfileVis = false;
    },
    getJoinedRequests(pagination) {
      // this.joinedLoading = true;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          `requests/${this.citRequest.id}/joinedRequests`,
        params: {
          limit: pagination.pageSize,
          offset: (pagination.current - 1) * pagination.pageSize,
          key:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.joinedRequests = response.data.data.entities;
            this.joinedRequestCount = response.data.data.totalCount;
          } else this.$message.error(response.data.error.message);
          this.joinedLoading = false;
        })
        .catch((err) => {
          this.joinedLoading = false;
          this.$message.error("Xəta baş verdi");
        });
    },
    onSameAddChange(e) {
      this.selectedFile.sameAddress = e.target.checked;
      this.citRequest.filesList.forEach((item) => {
        if (item.path === this.selectedFile.path) {
          item.sameAddress = e.target.checked;
        }
      });
    },
    getActions() {
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          `requests/${this.citRequest.id}/actions`,
        method: "GET",
        params: {
          menuUrl:
            window.location.pathname.split("/").length === 0
              ? ""
              : window.location.pathname.split("/")[1],
        },
      }).then((response) => {
        if (!response.data.error) {
          this.actions = response.data.data;
        } else this.$message.error(response.data.error.message);
      });
    },
    handleFileChange(file) {
      this.selectedFile = file;
      this.selectedExecutiveId = this.selectedFile.executive
        ? this.selectedFile.executive.id
        : null;
      this.address = this.selectedFile.address;
    },
    handleCompare(problem) {
      if (problem) {
        if (this.$refs["compare-field"]) {
          this.$refs["compare-field"].scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }

        this.compType = true;
        this.compareProblem = problem;
        apiCall({
          url:
            URL[process.env.NODE_ENV].service_api +
            "problems/" +
            problem.id +
            "/media",
        }).then((response) => {
          if (!response.data.error) {
            this.$set(this.compareProblem, "filesList", response.data.data);
          }
        });
      } else {
        this.compType = false;
        this.compareProblem = null;
      }
    },
    handleNearProblemsTotalCountChange(count) {
      this.nearProblemsCount = count;
    },
    toggleCompare() {
      this.compType = !this.compType;
    },
    handleTableChange({ pagination, filters, sorter }) {
      this.pagination = pagination;
      this.getJoinedRequests();
    },
    handleRowSelection(selectedRowKeys, selectedRows) {
     
      this.joinedRequestIds = selectedRowKeys;
    },
    handleNRowSelection(selectedRowKeys, selectedRows) {
      this.selectedNearRequestIds = selectedRowKeys;
    },
    handleConfirmOk(reason) {
      const message = this.$message;
      let sendData = this.dataToSend;
      console.log({sendData});
      sendData.reasonNote = reason;
      this.confirmModalVis = false;
      this.loading = true;
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          `requests/${sendData.citRequestId}`,
        method: "PUT",
        data: {
          ...sendData,
          prevProblemId: this.prevProblemId,
          prevProblemStatus: this.prevProblemStatus,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.willCallBeforeDestroy = false;

            window.location.href = "/main";
          } else {
            message.error(response.data.error.message);
          }
          this.loading = false;
        })
        .catch((err) => {
          message.error("Xəta baş verdi");

          this.loading = false;
        });
    },
    async submit(button) {
      console.log(this.coverMedia,'lllllllllllll');
      this.forRefButtonId &&
        this.$refs[this.forRefButtonId + "ref"][0].$el.classList.remove(
          "custom__active_color"
        );
      this.$refs[button.id + "ref"][0].$el.classList.add(
        "custom__active_color"
      );
      this.forRefButtonId = button.id;
      this.dataToSend = {
        action: button,
        citRequestId: this.citRequest.id,
        joinProblemId: this.selectedProblem ? this.selectedProblem.id : null,
        joinedRequestIds: this.joinedRequestIds?.length>0
          ? [...this.joinedRequestIds, ...this.selectedNearRequestIds]
          : [this.citRequest.joinedRequest?.id].filter(customFilter=>customFilter!=undefined),
      };

      this.dataToSend.currentPath =
        window.location.pathname.split("/").length === 0
          ? ""
          : window.location.pathname.split("/")[1];
let result
      if (button.dataRequired) {
        result = await this.$refs.cproblemForm.submit();
        this.dataToSend.title = result.title;
      }

      if (!this.dataToSend.joinProblemId && button.dataRequired) {
        if (!result)
          return (
            this.forRefButtonId &&
            this.$refs[this.forRefButtonId + "ref"][0].$el.classList.remove(
              "custom__active_color"
            )
          );

        this.dataToSend = { ...result, ...this.dataToSend };
        for (let i = 0; i < this.citRequest.filesList.length; i++) {
          if (!this.citRequest.filesList[i].sameAddress) {
            this.$message.error(
              "Faylların eyni ünvandan göndərildiyi təsdiq edilməlidir."
            );
            this.dataToSend = null;
            return;
          }
        }
      }
      if (button.dataRequired && !this.coverMedia) {

        this.$message.error("Şikayət üçün əsas şəkil seçilməyib");
        this.dataToSend = null;
        return;
      }
      if (button.dataRequired) {
        this.dataToSend.coverMedia = this.coverMedia;
      }

      this.confirmModalVis = true;
    },
    chooseDetail(problem, address) {
      if (this.selectedProblem && this.selectedProblem.id == problem.id) {
        this.selectedProblem = null;
        this.citRequest.address = null;
        this.citRequest.priorityLevel = null;
       
        this.title = null;
        this.handleCompare(null);
        return;
      }
      if(this.citRequest.joinedRequest&& this.citRequest.joinedRequest.id==problem.id){
        this.citRequest.joinedRequest=null
        return
      }
      this.selectedProblem = problem;
      this.handleCompare(this.selectedProblem);
      this.citRequest.selectedExecutiveId = problem.executive.id;
      this.citRequest.address = address;
      this.citRequest.priorityLevel = problem.priorityLevel;
      this.coverMedia = this.selectedProblem.coverMedia;
      this.title = problem.text;
    },
    handleConfirmClose() {
      this.$refs[this.forRefButtonId + "ref"][0].$el.classList.remove(
        "custom__active_color"
      );
      this.confirmModalVis = false;
    },
    reasonModalClose() {
      this.reasonsModalVis = false;
    },
    handleOpenProblem(id) {
      window.open(`${origin}/problems/${id}`);
    },
  },
  watch: {
    
    "$route.params.id": function (id) {
      if (this.created) {
        this.$forceUpdate();
        this.getCitRequestDetails();
      }
    },
    prevProblemStatus: {
      immediate: true,
      handler(val) {},
    },
    citRequest: {
      immediate: true,
      handler: function (val) {
        if (val) {
          EventBus.$emit("opened", {
            requestId: val.id,
            user: {
              id: this.userData.uuid,
              firstName: this.userData.firstName,
              lastName: this.userData.lastName,
              patronymic: this.userData.fatherName,
            },
          });
        }
      },
    },
  },
  created() {
    // const activeEdits = JSON.parse(getCookie("activeEdits"));

    // if (
    //     activeEdits &&
    //     activeEdits[this.$route.params.id] &&
    //     activeEdits[this.$route.params.id].isOpen
    //   )
    // {
    //   this.willCallBeforeDestroy = false;
    //   this.$router.push("/main");
    //   this.$message.info(`${activeEdits[this.$route.params.id].editor} bu müraciətə baxır`)
    //   return;
    // }

    document.addEventListener("scroll", this.handleMainContainerScroll);

    this.created = true;
    this.getCitRequestDetails();

    // window.addEventListener(
    //   "beforeunload",
    //   (_event) => {
    //     const edits = JSON.parse(getCookie("activeEdits"));
    //     let newEdits;

    //     if (!edits) newEdits = { [this.citRequest.id]: undefined };
    //     else newEdits = { ...edits, [this.citRequest.id]: undefined };

    //     const domain = process.env.NODE_ENV === "development" ? "localhost" : ".muraciet.az";

    //     document.cookie = `activeEdits=${JSON.stringify(
    //       newEdits
    //     )}; domain=${domain}; path=/;`;

    //     if (this.willCallBeforeDestroy)
    //       EventBus.$emit("closedBy", this.citRequest.id);
    //   },
    //   true
    // );
  },
  beforeDestroy() {
    // window.removeEventListener(
    //   "beforeunload",
    //   (_event) => {
    //     const edits = JSON.parse(getCookie("activeEdits"));
    //     let newEdits;
    //     if (!edits) newEdits = { [this.citRequest.id]: undefined };
    //     else newEdits = { ...edits, [this.citRequest.id]: undefined };
    //     const domain = process.env.NODE_ENV === "development" ? "localhost" : ".muraciet.az";
    //     document.cookie = `activeEdits=${JSON.stringify(
    //       newEdits
    //     )}; domain=${domain}; path=/;`;
    //     if (this.willCallBeforeDestroy)
    //       EventBus.$emit("closedBy", this.citRequest.id);
    //   },
    //   true
    // );
    // if (this.willCallBeforeDestroy) {
    //   const edits = JSON.parse(getCookie("activeEdits"));
    //   let newEdits;
    //   if (!edits) newEdits = { [this.citRequest.id]: undefined };
    //   else newEdits = { ...edits, [this.citRequest.id]: undefined };
    //   const domain = process.env.NODE_ENV === "development" ? "localhost" : ".muraciet.az";
    //   document.cookie = `activeEdits=${JSON.stringify(
    //     newEdits
    //   )}; domain=${domain}; path=/;`;
    //   EventBus.$emit("closedBy", this.citRequest.id);
    // }
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
